import * as React from "react";
import { BaseBlock, BaseBlockOptions, broadcastBlockLoad } from "sb-resp-lib";

import { BaseDict } from "./dict";
import { config } from "./config";
import { RacingCombinedView } from "./RacingCombinedView";
import { RacingCombinedViewData } from "./data";

/*
    This structure allows us to use mocks during dev
    but not to include them when we do build:release
*/
import * as MOCKSTYPE from "sb-resp-lib/lib/mocks";
import * as LOCALMOCKS from "../../mocks";
let _: typeof MOCKSTYPE;
let _localMocks: typeof LOCALMOCKS;
let PageMethodsMock;
let RacingPageMethodsMock;
let ApplicationNavigationMock;
let OverridenPageMethodsResponses;
let GetUniqueClassMock;
if (process.env.NODE_ENV === "development") {
    _ = require("sb-resp-lib/lib/mocks");
    _localMocks = require("../../mocks");
    PageMethodsMock = _.PageMethodsMock;
    RacingPageMethodsMock = _localMocks.RacingPageMethodsMock;
    ApplicationNavigationMock = _.NavHandlerMock;
    OverridenPageMethodsResponses = _localMocks.PageMethodsOverridenMockedMethods;
    GetUniqueClassMock = _.getUniqueOddsClass;
}

export class RacingCombinedViewRoot extends BaseBlock {
    dataProvider!: RacingCombinedViewData;
    options!: BaseBlockOptions;
    racingGameBlockNav!: Function;
    // constructor sets defaults
    constructor(
        domId: string,
        options: BaseBlockOptions = {
            dict: BaseDict,
            cms: {},
            navHandler: {},
            dataProvider: {}
        }
    ) {
        super(domId, options);

        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = { ...BaseDict, ...(options.dict || {}) };

        // merge default and CMS options
        this.options.cms = { ...config, ...(options.cms || {}) };

        if (process.env.NODE_ENV === "development") {
            this.racingGameBlockNav = () => { };

            // setup data mocks for debug build
            this.dataProvider = new RacingCombinedViewData(
                {
                    pageMethods: new PageMethodsMock(new OverridenPageMethodsResponses()),
                    racingPageMethods: new RacingPageMethodsMock(),
                    getUniqueOddsClass : GetUniqueClassMock
                },
                options.cms.nextRacesCount,
                new ApplicationNavigationMock());

            // setup dictionary for debug build
            this.options.dict = BaseDict;

            //export data store to window for debug purposes
            window["RacingCombinedViewDATA"] = this.dataProvider;
        }

        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            // use pagemethods passed during the construction from the
            // mobile application
            this.dataProvider = new RacingCombinedViewData(options.dataProvider, options.cms.nextRacesCount, options.navHandler.Navigation);
            this.racingGameBlockNav = OpenRacingGame;
        }
    }

    activate() {
        return super.activate(
            <RacingCombinedView dataProvider={this.dataProvider} dict={this.options.dict} options={this.options} racingGameBlockNav={this.racingGameBlockNav} />
        );
    }
}

window["RacingCombinedView"] = RacingCombinedViewRoot;
broadcastBlockLoad("RacingCombinedView");